import { render, staticRenderFns } from "./PostExplainlist.vue?vue&type=template&id=0cc048ac&scoped=true"
import script from "./PostExplainlist.vue?vue&type=script&lang=js"
export * from "./PostExplainlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc048ac",
  null
  
)

export default component.exports